import React from 'react';

// The Instagram Reels mark (tabler has none): the rounded frame, the clapper band with
// its two slashes, and the play triangle, drawn in tabler's stroke so it sits with the
// other icons. It takes the text colour (`currentColor`).
export default function ReelsIcon({ size = 24, stroke = 1.75, ...props }) {
  return <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={stroke}
    strokeLinecap="round" strokeLinejoin="round" aria-hidden="true" focusable="false" {...props}>
    <rect x="3" y="3" width="18" height="18" rx="5" />
    <path d="M3 8.5h18" />
    <path d="M8.5 3l3 5.5" />
    <path d="M14 3l3 5.5" />
    <path d="M10 12.4v4.2a.6 .6 0 0 0 .9 .52l3.6 -2.1a.6 .6 0 0 0 0 -1.04l-3.6 -2.1a.6 .6 0 0 0 -.9 .52z" />
  </svg>;
}
